// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"9147a9c7","450":"5bbd1363"}[chunkId] + ".chunk.js";
};